import { endpoints, request } from '!core/api';

export const trlDetailsServices = {
  instrumentMarketDepth: ({ symbol, exchange, securityType }) =>
    request.get(
      endpoints.chnn(
        `wsbGetInstrumentMarketDepth?symbol=${symbol}&exchange=${exchange}&securityType=${securityType}`,
      ),
    ),
  lastTradeService: ({ symbol, exchange, securityType }) =>
    request.get(
      endpoints.chnn(
        `wsbGetInstrumentLastTrades?symbol=${symbol}&exchange=${exchange}&securityType=${securityType}`,
      ),
    ),
  DetaisService: ({ symbol, exchange, securityType }) =>
    request.get(
      endpoints.backoffice(
        `WsbGetSecurityInfo?symbol=${symbol}&exchange=${exchange}&securityType=${securityType}`,
      ),
    ),
  FilesService: ({ noteId }) =>
    request.get(endpoints.frameworkbo(`attachIds?noteId=${noteId}`)),
  DownloadService: ({ noteAttachId }) =>
    request.downloadFile(
      endpoints.frameworkbo(`DownloadAttach?noteAttachId=${noteAttachId}`),
    ),
};
